import Axios from "axios";
import config from "../app.config";

export var notificationService;
export default notificationService = {
  getNotifications,
}

async function getNotifications(mailBox) {
  return await Axios.get(`${config.LOCAL_API_URL}/getNotifications/${mailBox}`)
    .then(response => {
      if (response.data) {
        return Promise.resolve(response.data);
      } else {
        return Promise.reject(response);
      }
    }).catch(error => {
      return Promise.reject(error);
    })
}